/**
 * @generated SignedSource<<48a792d871b35fe45c3058997c2975e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ContraVerificationStatus = "NEEDS_PAYOUT_METHOD" | "NOT_STARTED" | "PENDING" | "REJECTED" | "STRIPE_VERIFICATION_IN_PROCESS" | "VERIFIED" | "%future added value";
export type ProfileDisplayType = "BASIC" | "BLOG" | "RESOURCE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type Location_userProfile$data = {
  readonly location: string | null;
  readonly locationGooglePlaceId: string | null;
  readonly profileDisplayType: ProfileDisplayType;
  readonly verificationStatus: ContraVerificationStatus;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentType": "Location_userProfile";
};
export type Location_userProfile$key = {
  readonly " $data"?: Location_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"Location_userProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Location_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileDisplayType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locationGooglePlaceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verificationStatus",
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "b6b600a4a8754b0294c44b6ed30135c1";

export default node;
